import { dispatchProps } from "../../../cnr/reducers/reducerHelpers/dispatchProps";
import { createRefPath } from "../../appData/appRefPaths";
import { createFsDocKey } from '../../appData/fsAppData';

export const fsUpdate_updateImageLinks = (props) => {

  const {
    appUser,
    baseRef,
    dispatch,
    ufProps,
    database_fns
  } = props

  const { refPath } = baseRef
  const { uid } = appUser ?? {}
  let { viewKey, view, urlLink, dataRestrictions } = ufProps ?? {}

  if (view && viewKey && urlLink) {

    const _setRef = createRefPath(['imageLinks', database_fns.get_docKey('imageLink')], refPath)

    const updateData = {
      urlLink,
      uid,
      parentKeys: {
        view,
        viewKey
      }
    }

    if (dataRestrictions && (dataRestrictions.all || dataRestrictions.updateImageLinks)) {
      console.log('updateData', updateData)
      dispatch({ type: dispatchProps.successAlt, dispatch })
      return false
    }
    database_fns.set_doc(_setRef, updateData, false, dispatch)
  } else {
    alert('Item not rated. No viewItemKey')
  }
}